const __WEBPACK_NAMESPACE_OBJECT__ = require("@dnd-kit/sortable");